import React, { useState } from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { logErrorToConsole } from 'src/utils/util';
import {
    FilterComponentWrapper,
    FilterComponentHeaderFooter,
    TextBold,
    LineSeparator,
} from './index.styled';
import CommonRadioCheckboxFilter from 'src/common/refactoredComponents/filter/CommonRadioCheckboxFilter.jsx';
import { Dot } from 'src/styles/CommonStyles.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const FilterDefaultCheckbox = ({
    header,
    filters,
    onCheckBoxChange,
    isExpanded,
    updateExpandedViews,
    checkBoxName,
    view,
    showDefault,
    selectedViewFilter,
    isAdmin,
    setDefaultAction,
    setDefaultView,
    //key,
}) => {
    const [isAppliedFilter,] = useState(false);
    const [isSetAsDefault, setIsSetAsDefault] = useState(false);
    const hasDefaultViewChanged = () => {
        if (
            selectedViewFilter &&
            selectedViewFilter.length > 0 &&
            selectedViewFilter.filter(
                (item) =>
                    (!item.isDefault && item.isChecked) ||
                    (item.isDefault && !item.isChecked)
            ).length > 0 &&
            selectedViewFilter.filter((item) => item.isChecked).length > 0
        ) {
            setIsSetAsDefault(true);
        } else {
            setIsSetAsDefault(false);
        }
    };
    useEffectWithErrorLogging(() => {
        hasDefaultViewChanged();
        // let salesOrgData = [...saleOrgView];
        // // if (salesOrgData.filter((item) => item.isDefault).length == 0) {
        // //     salesOrgData[0].isChecked = true;
        // // }
        // salesOrgData.map((item) => {
        //     if (item.isDefault) {
        //         item.isChecked = true;
        //     }
        // });
        // let arr3 = filters.map((item, i) =>
        //     Object.assign({}, item, salesOrgData[i])
        // );
        // console.log('check', selectedViewFilter);
        // setSalesOrgViewData(
        //     filters.map((item, i) => Object.assign({}, item, salesOrgData[i]))
        // );
    }, [filters]);
    const { t } = useTranslation();
    // useEffectWithErrorLogging(() => {
    //     isDefault
    //         ? setAppliedFilter(anyAppliedFilterCheckDefault(filters, isDefault))
    //         : setAppliedFilter(anyAppliedOrCheckedFilter(filters));
    // }, [filters, isExpanded, allFiltersWithStatus]);

    return (
        <FilterComponentWrapper
            className={
                filters?.filter((item) => item.name !== 'All').length > 0
                    ? ''
                    : 'disabled'
            }
        >
            <FilterComponentHeaderFooter
                id={`admin-filter-defaultCheckbox-header-${view}`}
                onClick={() => {
                    try {
                        updateExpandedViews({
                            view: view,
                            value: !isExpanded,
                        });
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
            >
                <TextBold color={'#140F4B'}>{header}</TextBold>

                {isExpanded ? (
                    <img
                        src={DownArrowFilter}
                        style={{ transform: 'rotate(180deg)' }}
                    ></img>
                ) : (
                    <>
                        <div>
                            {isAppliedFilter ? <Dot /> : ''}
                            <img src={DownArrowFilter}></img>
                        </div>
                    </>
                )}
            </FilterComponentHeaderFooter>
            {(() => {
                if (isExpanded) {
                    return (
                        <>
                            <LineSeparator />
                            {filters &&
                                filters?.map((filter, index) => {
                                    return (
                                        <CommonRadioCheckboxFilter
                                            isCheckbox={true}
                                            key={filter.statusCode}
                                            filterItem={
                                                filter.name === 'All'
                                                    ? filter.name
                                                    : filter.name +
                                                    ' ' +
                                                    filter.value
                                            }
                                            filterItemId={filter.value}
                                            iconUrl={false}
                                            checkBoxName={checkBoxName}
                                            onCheckBoxChange={onCheckBoxChange}
                                            index={index}
                                            isChecked={filter?.isChecked}
                                            isDefault={
                                                showDefault
                                                    ? filter.isDefault
                                                    : false
                                            }
                                            labelWidth={'auto'}
                                            labelMbWidth={'auto'}
                                            width={'auto'}
                                            isAdmin={isAdmin}
                                        />
                                    );
                                })}
                            {setDefaultAction ? (
                                <FilterComponentHeaderFooter>
                                    <Button
                                        id={'page-admin-filter-setDefault'}
                                        show={true}
                                        width={'100%'}
                                        height={'38px'}
                                        clicked={() => {
                                            try {
                                                setDefaultView(
                                                    selectedViewFilter,
                                                    true
                                                );
                                                //setDefaultClicked(true);
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        // primary={isSetAsDefault}
                                        disabled={!isSetAsDefault}
                                        variant={ isSetAsDefault ? ButtonStyles.primary : ButtonStyles.disabled}
                                    >
                                        <TextBold
                                            color={'#FFFF'}
                                            style={{ fontSize: '15px' }}
                                        >
                                            {t('filter.setDefaultButton')}
                                        </TextBold>
                                    </Button>
                                </FilterComponentHeaderFooter>
                            ) : null}
                        </>
                    );
                } else {
                    return <></>;
                }
            })()}
        </FilterComponentWrapper>
    );
};

export default FilterDefaultCheckbox;
